<template>

  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
      <page-header-wrapper>
        <a-card :bordered="false">
          <!-- 条件搜索 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="48">
                <a-col :md="8" :sm="24">
                  <a-form-item label="用户昵称" prop="userId">
                    <a-input v-model="queryParam.userName" placeholder="请输入用户昵称" allow-clear/>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="绑定的用户昵称" prop="superUserId">
                    <a-input v-model="queryParam.superUserName" placeholder="请输入绑定的用户昵称" allow-clear/>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="时间">
                    <a-range-picker
                      :placeholder="['开始时间', '结束时间']"
                      @change="onDateChange"
                      format="YYYY-MM-DD"></a-range-picker>
                  </a-form-item>
                </a-col>
                <a-col :md="!advanced && 8 || 24" :sm="24">
                  <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                    <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                    <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- 操作 -->
          <div class="table-operations">
            <a-button type="primary" @click="handleExport">
              <a-icon type="download" />导出
            </a-button>
            <table-setting
              :style="{float: 'right'}"
              :table-size.sync="tableSize"
              v-model="columns"
              :refresh-loading="loading"
              @refresh="getList" />
          </div>
          <p style="color: red">
            总收益：{{allMoney}}
          </p>
          <p style="color: red">
              注意：统计的收益存在48小时的延迟。
          </p>
          <!-- 数据展示 -->
          <a-table
            :loading="loading"
            :size="tableSize"
            rowKey="id"
            :columns="columns"
            :data-source="list"
            :pagination="false"
            :bordered="tableBordered"
          >
            <span slot="createTime" slot-scope="text, record">
              {{ parseTime(record.createTime) }}
            </span>
          </a-table>
          <!-- 分页 -->
          <a-pagination
            class="ant-table-pagination"
            show-size-changer
            show-quick-jumper
            :current="queryParam.pageNum"
            :total="total"
            :page-size="queryParam.pageSize"
            :showTotal="total => `共 ${total} 条`"
            @showSizeChange="onShowSizeChange"
            @change="changeSize"
          />
        </a-card>
      </page-header-wrapper>
  </a-drawer>
</template>

<script>
import {pageUserLookAds, listUserLookAds, delUserLookAds, numUserLookAds} from '@/api/platform/userLookAds'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserLookAds',
  components: {
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      allMoney: 0.0,
      agencyUserId: null,
      // 高级搜索 展开/关闭
      advanced: false,
      open: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        superUserId: null,
        lookNum: null,
        lookTime: null,
        addMoney: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户昵称',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户手机号',
          dataIndex: 'userMobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '绑定的用户昵称',
          dataIndex: 'superUserName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '绑定的用户手机号',
          dataIndex: 'superUserMobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '观看次数',
          dataIndex: 'lookNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '时间',
          dataIndex: 'lookTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '新增收益',
          dataIndex: 'addMoney',
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    show(agencyUserId){
      this.open = true
      this.agencyUserId = agencyUserId
      this.getList();
    },
    onClose () {
      this.open = false
    },
    /** 查询用户完成广告记录列表 */
    getList () {
      let that = this;
      that.loading = true
      that.queryParam.agencyUserId = that.agencyUserId;
     pageUserLookAds(that.queryParam).then(response => {
       that.list = response.data.records
       that.total = response.data.total
       that.loading = false
       numUserLookAds(that.queryParam).then(response => {
          that.allMoney = response.data
       })
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        superUserId: undefined,
        lookNum: undefined,
        lookTime: undefined,
        addMoney: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    onDateChange(value, dateString) {
      console.log(dateString[0],dateString[1]);
      this.queryParam.startTime=dateString[0];
      this.queryParam.endTime=dateString[1];
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUserLookAds(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('platform/user-look-ads/export', {
            ...that.queryParam
          }, `用户完成广告记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
